export class HeaderPeticion {

    nombre: string;
    valor: string;

    constructor(nombre, valor) {
        this.nombre = nombre;
        this.valor = valor;
     }

}


// WEBPACK FOOTER //
// ./src/app/models/http/headerPeticion.class.ts